import React from 'react';
import classNames from 'classnames';

const FaqBlock = ({ faqDropdown, question, answer, slug, changeFaq }) =>  {

  const contentClass = classNames({
    '-content': true,
    'open': faqDropdown === slug
  });

  const faqClick = (slug) => {
    changeFaq(slug);
  }

  return (
    <li onClick={() => faqClick(slug)} className="-block">
        <span className="-toggle">
        <p dangerouslySetInnerHTML={{__html: question}}></p>
        <span className="caret"></span>
        </span>
        <div className={contentClass}>
            <p dangerouslySetInnerHTML={{__html: answer}}></p>
        </div>
    </li>
  );
}

export default FaqBlock;



/** WEBPACK FOOTER **
 ** ./src/components/Scenes/Faq/FaqBlock.js
 **/